import { render } from "./AboutUs.vue?vue&type=template&id=671501d7&scoped=true"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=671501d7&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\ATL\\Desktop\\Dev\\p2-osavus\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671501d7"]])

export default __exports__